module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAPFBMVEUAAAAAfekAfekAgOsAeeYAfenq8/4Afen/tDkFgOnl8f3+tTx9vPRttPNrs/L10ZTEuJD+tkC02Pm12PmWsGhFAAAABnRSTlMA8q0mKK6zoN9jAAAAvklEQVRo3u3ZQQ6CMBBAUVqQKRSF4v3v6kQDGl20oTEB+v+2gZdJk26mIqKyq62RtaFvn/WTd1/5aTkbZM3YJslQ4p3+51VwP4XlrJePTJ2AWNE2T6LZBEQHmdvNzTpKAiIibUb6OQgICAgICEgecuskUnfNRtSIKseY5DwXDwICshOEV3h/dwICAlISMnoXyY/ZSHDRwjEmOc/Fg4CAgICAgJwEMSL3vy8zrWRm0xbMWZk6cVWeQVyaioiK7gF2GIFNeyG/GAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSelfPrinting/service_3.png
// module id = MuEJ
// module chunks = 10